<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
				<template #search>
					<m-search ref="search" :extend-data="defaultSearchData">
						<!-- 平台积分账户余额汇总 -->
						<div class="stats-bar flex">
							<div class="stats-card card-orange">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">渠道上架积分</span>
										<span class="stats-value">{{formatPoints(balance.channel_points)}}</span>
									</div>
								</div>
								<div class="stats-icon">分</div>
							</div>
							<div class="stats-card card-green">
								<div class="stats-info">
									<div class="stats-title-row flex-start-center">
										<span class="stats-label">IMIE积分</span>
										<span class="stats-value">{{formatPoints(balance.imie_points)}}</span>
									</div>
								</div>
								<div class="stats-icon">分</div>
							</div>
						</div>

						<m-search-item label="记录单号">
							<c-input name="record_number"></c-input>
						</m-search-item>
						<m-search-item label="业务单号">
							<c-input name="docket_number"></c-input>
						</m-search-item>
						<m-search-item label="创建时间">
							<c-datetime range name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_platform_points_account_export')"
							  prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
					</c-button>
				</template>

				<!--账户类型-->
				<template #account_type="{data}">
					<c-state tag async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
				</template>
				<!--收支类型-->
				<template #income_expenses="{data}">
					<c-state tag async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
				</template>
				<!--收支状态-->
				<template #trans_state="{data}">
					<c-state tag async dict="TRANS_STATE" :value="data.trans_state"></c-state>
				</template>
				<!--变动积分（积分数值由后端实体getMoney转换，无需分转元）-->
				<template #money="{data}">
					{{data.money}}
				</template>
				<!--积分余额（积分数值由后端实体getSurplus_money转换，无需分转元）-->
				<template #surplus_money="{data}">
					{{data.surplus_money}}
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'p_platform_points_account',

	data() {
		return {
			workType: 126,
			//平台积分账户余额汇总（渠道上架积分 / IMIE积分）
			balance: {
				channel_points: 0,
				imie_points: 0
			},
			defaultSearchData: {
				trans_states: [1, 3]  //不展示【2：处理中】的记录
			}
		}
	},

	computed: {
		...mapState(['saasInfo'])
	},

	mounted() {
		this.loadBalance();
	},

	methods: {
		/**
		 * 加载平台积分账户余额汇总（顶部资金汇总卡片）
		 */
		loadBalance() {
			this.request({
				url: '/financial/platform/account/balance',
				data: {},
				success: data => {
					this.balance = {
						channel_points: data && data.channel_points ? data.channel_points : 0,
						imie_points: data && data.imie_points ? data.imie_points : 0
					};
				}
			});
		},

		/**
		 * 积分格式化（积分无单位换算，直接展示数值）
		 */
		formatPoints(val) {
			if (val === undefined || val === null || val === '') {
				return '0';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0' : num.toLocaleString();
		}
	}
}
</script>

<style lang="stylus" scoped>
	.stats-bar {
		flex-wrap: wrap;
		gap: 10px;
		width: 100%;
		border-top: 1px solid #F5F5F5;
		padding: 8px 12px;

		.stats-card {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 260px;
			max-width: 45%;
			min-height: 56px;
			padding: 8px 16px;
			border-radius: 6px;
			color: #fff;
			box-sizing: border-box;
			overflow: hidden;

			&.card-orange {
				background: linear-gradient(90deg, #f97316, #fb923c);
			}

			&.card-green {
				background: linear-gradient(90deg, #16a34a, #22c55e);
			}

			.stats-info {
				position: relative;
				z-index: 1;

				.stats-title-row {
					display: flex;
					align-items: baseline;
					line-height: 24px;

					.stats-label {
						font-size: 12px;
						opacity: 0.95;
					}

					.stats-value {
						margin-left: 6px;
						font-size: 18px;
						font-weight: bold;
					}
				}

				.stats-summary-row {
					gap: .5em;
					margin-top: 2px;
					font-size: 11px;

					label {
						opacity: 0.9;
					}
				}
			}

			.stats-icon {
				position: absolute;
				right: 14px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 32px;
				line-height: 1;
				opacity: 0.15;
			}
		}
	}
</style>